globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Social = appCustomerSpace.Modals.Social || {};

appCustomerSpace.Modals.Social.PostCommentaryAIGeneration = (function (superClass) {

  utils.extend(PostCommentaryAIGeneration, superClass);

  function PostCommentaryAIGeneration() {
    return PostCommentaryAIGeneration.__super__.constructor.apply(this, arguments);
  }

  $.extend(PostCommentaryAIGeneration.prototype, {
    init: function () {
      var _this = this;

      var $subjectField = _this.$html.find('input#social_post_form_ai_full_writing_from_user_prompt_subject');

      if ($subjectField.length > 0) {
        $subjectField.on('input', function() {
          var $promptInstructions = _this.$html.find('.prompt-instructions');

          if ($(this).val().length > 0) {
            $promptInstructions.removeClass('hidden');
          } else {
            $promptInstructions.addClass('hidden');
          }
        });
      }

      return PostCommentaryAIGeneration.__super__.init.apply(this, arguments);
    },
    updateView: function (data) {
      if (data.errors) {
        new PNotify({ icon: 'icon-cross2', title: data.errors.join(', '), type: 'error', delay: 3000 });
      } else if (data.form_html) {
        appCustomerSpace.currentController.reloadForm(data);
      }
    }
  });

  return PostCommentaryAIGeneration;

})(appCustomerSpace.Modal);
